import { gql } from '@apollo/client'

export const getQmrAttachmentAnnotationsQuery = gql`
    query getQmrAttachmentAnnotationsImDfmModal(
        $attachmentId: UUID!
        $quoteModelRevisionId: UUID
    ) {
        getQmrAttachmentAnnotations(
            attachmentId: $attachmentId
            quoteModelRevisionId: $quoteModelRevisionId
        ) {
            id
            annotationsDataDownloadUrl
        }
    }
`

export default getQmrAttachmentAnnotationsQuery
